import {ChangeDetectorRef, Component, Inject, Input} from '@angular/core';
import {Observable} from 'rxjs';
import {AutoTypesRecommendation, HotelRecommendation} from 'src/app/models';
import {ApiService} from 'src/app/services/api.service';
import {pluralize} from '../../pipes/pluralize/pluralize';
import {environment} from "../../../../environments/environment";
import {HOTEL_TOURS_PAGE_CONFIG, HotelToursPageConfig} from "../../../config/hotel-tours-list-page.config";
import { TemplateReplacePipe } from '../../pipes/trmplate-replace/template-replace.pipe';

@Component({
  selector: 'app-tour-recommendations',
  templateUrl: environment.mobile ? './tour-recommendations.component.mobile.html' : './tour-recommendations.component.html',
  styleUrls: environment.mobile ? ['./tour-recommendations.component.mobile.scss'] : ['./tour-recommendations.component.scss'],
  standalone: true,
  imports: [TemplateReplacePipe]
})
export class TourRecommendationsComponent {
  @Input() tour: any;
  @Input() open$: Observable<void>;

  recommendations!: HotelRecommendation[];

  isLoading = true;
  isShowRecommendationContent = false;
  hasRecommendations = false;
  isSendRequest = false;
  byesType = AutoTypesRecommendation.BAYES_RECOMMENDATION_TYPE;

  showRating = false;
  showSales = false;
  showReviews = false;
  messages: any = {};

  constructor(
    @Inject(HOTEL_TOURS_PAGE_CONFIG) private hotelToursPageConfig: HotelToursPageConfig,
    private apiService: ApiService, private cdRef: ChangeDetectorRef
  ) {
    this.messages = Object.assign(
      {},
      this.hotelToursPageConfig.translates.tourRecommendations,
      {
        pluralTours: this.hotelToursPageConfig.translates.plurals.pluralTours,
        oncePlural: this.hotelToursPageConfig.translates.plurals.oncePlural,
        reviewsPlural: this.hotelToursPageConfig.translates.plurals.reviewsPlural,
      }
    );
  }

  ngOnInit() {
    // Отключает показ блока с рекомендациями в картинках отеля, по просьбе Максима
    // для возвращения в работу, удалите проверку if (this.isShowRecommendationContent)
    if (this.isShowRecommendationContent) {
      if (this.open$) {
        this.open$.subscribe(() => {
          this.showRecommendationsText(event);
        });
      }
    }
  }

  get salesCount() {
    return pluralize(this.tour.salesCount, this.messages.oncePlural);
  }

  countReviewsMapping(countReviews) {
    return {
      'countReviewsVal': countReviews,
      'countReviewsText': this.reviewsCountText(countReviews),
    }
  }

  countToursMapping(countTours) {
    return {
      'countToursVal': countTours,
      'countToursText': this.salesCountText(countTours),
    }
  }

  showRecommendationsText(event) {
    // Отключает показ блока с рекомендациями в картинках отеля, по просьбе Максима
    // для возвращения в работу, удалите проверку if (this.isShowRecommendationContent)
    if (this.isShowRecommendationContent) {
      if (event) {
        event.stopPropagation();
      }

      if (!this.isSendRequest) {
        this.apiService
            .getHotelRecommendation(this.tour.hotelId)
            .subscribe((recommendationsData: HotelRecommendation[]) => {
              if (recommendationsData.length) {
                this.recommendations = this.filterRecommendation(recommendationsData);
                this.hasRecommendations = true;

                this.isShowParams();
              }

              this.isLoading = false;
              this.isSendRequest = true;
              this.isShowRecommendationContent = true;
              this.cdRef.detectChanges();
            });
      } else {
        this.isShowRecommendationContent = true;
      }
    }
  }

  hideRecommendations(event) {
    event.stopPropagation();
    this.isShowRecommendationContent = false;
  }

  filterRecommendation(recomendations: HotelRecommendation[]) {
    const bayesRecommendations = [];
    const otherRecommendations = [];

    for (const recommendation of recomendations) {
      if (recommendation.type === AutoTypesRecommendation.BAYES_RECOMMENDATION_TYPE) {
        // Если есть рекомендация по рейтингу то будет выводится только она
        // так как у нее свой формат вывода
        bayesRecommendations.push(recommendation);
      } else {
        // Если рекомендации по рейтингу нет то выводим стандартным списком все рекомендаци
        otherRecommendations.push(recommendation);
      }
    }

    return bayesRecommendations.length > 0 ? bayesRecommendations : otherRecommendations;
  }

  public reviewsCountText(value) {
    return pluralize(value, this.messages.reviewsPlural);
  }

  public salesCountText(value) {
    return pluralize(value, this.messages.pluralTours);
  }

  public isShowParams() {
    for (const recommendation of this.recommendations) {
      if (recommendation.type === AutoTypesRecommendation.BAYES_RECOMMENDATION_TYPE) {
        this.showRating = true;
      }

      if (recommendation.type === AutoTypesRecommendation.SALES_RECOMMENDATION_TYPE) {
        this.showSales = true;
      }
    }

    this.showReviews = this.tour.bookingReviewsCount > 0;
  }
}
